module.exports = __webpack_public_path__ + "img/gif_fireworks_.a6d553c5.gif";